import React from 'react';
import styles from './slider.module.css';

/**
 * 차량 실내 사진.
 * 좌우로 넘기는 슬라이드는 모바일에서 버튼이 사진을 가려 쓰기 어려웠다.
 * 이제 한 줄에 2장씩 격자로 펼쳐 보여준다.
 */
const Slider = ({ imageList }) => {
  const images = imageList ?? [];

  return (
    <ul className={styles.photoGrid}>
      {images.map((image, index) => (
        <li key={image.url} className={styles.photoItem}>
          <img
            className={styles.photo}
            src={image.url}
            alt={`차량 내부 사진 ${index + 1}`}
            loading='lazy'
          />
        </li>
      ))}
    </ul>
  );
};

export default Slider;
